import React, { useState } from "react";

import { GenericLogs } from "../../../../components/GenericLogs/GenericLogs";
import { fetchMeetingLogs, fetchMeetingLogsDetailed } from "./MeetingLogs.function";
import { transformMeetingLog } from "./MeetingLogs.transform";

const MeetingLogs = ({ meetingId, language }: { meetingId: string; language: string }) => {
  const [detailed, setDetailed] = useState(false);

  return (
    <GenericLogs
      key={detailed ? "detailed" : "simple"}
      entityId={meetingId}
      language={language}
      fetchLogs={detailed ? fetchMeetingLogsDetailed : fetchMeetingLogs}
      translationPrefix="PAGES.MEETING.LOGS.ATTRIBUTES"
      transformDetailedLog={transformMeetingLog}
      detailedConfig={{
        enabled: true,
        value: detailed,
        onToggle: () => setDetailed((prev) => !prev),
      }}
    />
  );
};

export default MeetingLogs;
